import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function AccountLedgerPage() {
  const [data, setData] = useState({ summary: {}, entries: [] });
  useEffect(() => { (async () => { try { const { data } = await api.get("/ledger"); setData(data); } catch (err) { if (typeof console !== 'undefined') console.debug('pages/resident/AccountLedgerPage.jsx: swallowed', err); } })(); }, []);
  const s = data.summary || {};
  return (
    <div>
      <PageHeader eyebrow="Financial" title="Account Ledger" subtitle="Charges, payments, and balance." />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <Card className="p-5 bg-white">
          <div className="overline">Balance</div>
          <div className={"mt-2 text-3xl font-semibold font-display tabular-nums " + ((s.balance || 0) < 0 ? "text-rose-600" : "text-emerald-600")}>
            ${Math.abs(s.balance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
          <div className="text-xs text-muted-foreground mt-1">{s.aging_bucket ? s.aging_bucket.replaceAll("_"," ") : "current"}</div>
        </Card>
        <Card className="p-5 bg-white">
          <div className="overline">Days past due</div>
          <div className="mt-2 text-3xl font-semibold font-display tabular-nums">{s.days_past_due || 0}</div>
        </Card>
        <Card className="p-5 bg-white">
          <div className="overline">Payments recorded</div>
          <div className="mt-2 text-3xl font-semibold font-display tabular-nums">{data.entries.length}</div>
        </Card>
      </div>
      <Card className="overflow-hidden bg-white">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Memo</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Amount</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.entries.map((e) => (
              <TableRow key={e.session_id}>
                <TableCell>{new Date(e.created_at).toLocaleDateString()}</TableCell>
                <TableCell className="capitalize">{(e.payment_type || "").replaceAll("_"," ")}</TableCell>
                <TableCell className="text-sm text-zinc-600 max-w-xs truncate">{e.memo || "—"}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={e.payment_status === "paid" ? "bg-emerald-50 border-emerald-200 text-emerald-700" : "bg-amber-50 border-amber-200 text-amber-700"}>
                    {e.payment_status}
                  </Badge>
                </TableCell>
                <TableCell className="text-right tabular-nums">${Number(e.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
              </TableRow>
            ))}
            {data.entries.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground p-6">No transactions yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
